<template>
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-4">
            <img :src="img" class="card-img" :alt="title">
            <div class="img-lines"></div>
            </div>
            <div class="col-md-8">
            <div class="card-body">
                <h4 class="card-title">{{title}}</h4>
                <p><strong>{{subtitle}}</strong></p>
                <hr>
                <p class="card-text">{{text}}</p>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Person',
        props: {
            img: String,
            title: String,
            subtitle: String,
            text: String,
            index: Number
        }
    }
</script>
<style scoped>
    hr {
        margin-top: -0.5rem;
        margin-bottom: 0.5rem;
    }
    
    @media (min-width: 768px) {
        hr {
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
        }
    }
    @media (min-width: 1200px) {
        hr {
            margin-top: 1rem;
            margin-bottom: 2rem;
        }
    }
    .card {
        flex: 0 0 100%;
        margin-bottom: 15px;
    }

    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) and (min-width: 768px) {
        .card-deck > .card > .row > div {
            overflow: hidden; /* Make sure image is contained in IE, but may become cropped at bottom */
        }

        .card-img {
            position: absolute;
            /* This makes sure that adjacent content is not being pushed down in IE */
        }
    }
</style>